import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const STATE_CHALLENGE = 'challenge'
export const STATE_USER_ID = 'userID'
export const STATE_LOGIN_TYPE = 'loginType'

export const SET_CHALLENGE = 'setChallenge'
export const SET_USER_ID = 'setUserID'
export const SET_LOGIN_TYPE = 'setLoginType'

export default new Vuex.Store({
  state: {
    [STATE_CHALLENGE]: '',
    [STATE_USER_ID]: 0,
    [STATE_LOGIN_TYPE]: null // user by default for theming
  },
  getters: {
    [STATE_CHALLENGE]: state => {
      const challenge = state[STATE_CHALLENGE]
      if (challenge) return challenge
      return localStorage.getItem(STATE_CHALLENGE)
    },
    [STATE_USER_ID]: state => {
      const userID = state[STATE_USER_ID]
      if (userID) return userID

      const val = parseInt(localStorage.getItem(STATE_USER_ID))
      if (isNaN(val)) {
        console.warn(`NaN value for ${STATE_USER_ID} in local storge: ${localStorage.getItem(STATE_USER_ID)}`)
        return 1
      }
      return val
    },
    [STATE_LOGIN_TYPE]: state => {
      const loginType = state[STATE_LOGIN_TYPE]
      if (loginType) return loginType

      const val = parseInt(localStorage.getItem(STATE_LOGIN_TYPE))
      if (isNaN(val)) {
        console.warn(`NaN value for ${STATE_LOGIN_TYPE} in local storge: ${localStorage.getItem(STATE_LOGIN_TYPE)}`)
        return 1
      }
      return val
    }
  },
  mutations: {
    [SET_CHALLENGE] (state, challenge) {
      state.challenge = challenge
      localStorage.setItem(STATE_CHALLENGE, challenge)
    },
    [SET_USER_ID] (state, userID) {
      state.userID = userID
      localStorage.setItem(STATE_USER_ID, userID)
    },
    [SET_LOGIN_TYPE] (state, loginType) {
      state.loginType = loginType
      localStorage.setItem(STATE_LOGIN_TYPE, loginType)
    }
  },
  actions: {
  },
  modules: {
  }
})
